<template>
  <div class="cat-tiposresultado-sinoj">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de resultado</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los resultados</option>        
        <option v-for="(tipoResultado,index) in tiposDeResultado" :value="tipoResultado.TipoResultadoId" :key="index">{{tipoResultado.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        tiposDeResultado: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 015TiposResultado
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }
        let tipoResultadoObj = this.obtenertipoResultadoObj(evento.target.value);
        this.$store.dispatch("A_SINOJ_Catalogos_establecer015TiposResultado",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento,tipoResultadoObj);
      },
      obtenertipoResultadoObj: function(tipoResultadoId) {
        let id = parseInt(tipoResultadoId);
        let tipoResultado = null;
        this.tiposDeResultado.filter(trBD => trBD.TipoResultadoId == id).forEach(tr => {tipoResultado = tr});
        return tipoResultado;
      },
      /**
       * Metodo para llenar catalogo 015TiposResultado mediante el llamado de la API
       */
      cargarTiposDeResultado: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API = api.SINOJ.catalogos.C015TiposDeResultado;
        let urlApi = SERVIDOR + METODO_API;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        
        let peticionMetodoGetZonasAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);

        axios.post(urlApi, peticionMetodoGetZonasAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else { 
                        this.tiposDeResultado = respuesta.data.TiposResultado;
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SINOJ_Catalogos_establecer015TiposResultado", valoresDelCatalogo);
    },
    created() {
      this.cargarTiposDeResultado();
    }
  }
</script>
<style>
.cat-tiposresultado-sinoj .form-control {
  background-color: white !important;
        color: black !important;
}
</style>




// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C015TiposDeResultado.vue